import { types } from "../Actions/types";
// import { cloneDeep, merge } from "lodash";


const initialState = {
    totalWorkoutReport: {
        workouts: {
            dates: [],
            recordcounts: []
        },
        reps: {
            dates: [],
            recordcounts: []
        },
        duration: {
            dates: [],
            recordcounts: []
        },
        caloriesBurnt: {
            dates: [],
            recordcounts: []
        },
        timeUnderTension: {
            dates: [],
            recordcounts: []
        },
        totalWeightLifted: {
            dates: [],
            recordcounts: []
        },
        avgWorkoutDuration: {
            dates: [],
            recordcounts: []
        },
        avgSessionDuration: {
            dates: [],
            recordcounts: []
        }
    },
    strengthAssessmentReport: { dates: [], recordcounts: [] },
    userGoalCountReport: {
        getStronger: {
            dates: [],
            recordcounts: []
        },
        getLeaner: {
            dates: [],
            recordcounts: []
        }
    },
    workoutCompletedReport: {
        count: {
            dates: [],
            recordcounts: []
        },
        duration: {
            dates: [],
            recordcounts: []
        }
    },
    exerciseWiseStrengthAssessmentReport: { dates: [], recordcounts: [] },
    exerciseCategoryWiseWorkoutCompletedReport: { dates: [], recordcounts: [] },
    totalWeightsLiftedReport: { dates: [], recordcounts: [] },
    workoutSessionSplitMinutes: { dates: [], recordcounts: [] },
    // exerciseWiseStrengthAssessment:{dates:[],recordcounts:[]}
    totalWorkoutsCompletedHourly: {
        workouts: {
            dates: [],
            recordcounts: []
        }
    }

};

const WorkOutAnalyticsReportReducer = (state = initialState, action) => {
    const { type, payload } = action;

    switch (type) {
        case types.TOTAL_WORKOUT_REPORT:
            return {
                ...state,
                totalWorkoutReport: payload,
            };


        case types.STRENGTH_ASSESSMENT_REPORT:
            return {
                ...state,
                strengthAssessmentReport: payload,
            };

        case types.USER_GOAL_COUNT_REPORT:
            return {
                ...state,
                userGoalCountReport: payload,
            };
        case types.WORKOUT_COMPLETED_REPORT:
            return {
                ...state,
                workoutCompletedReport: payload,
            };
        case types.EXERCISE_WISE_STRENGH_ASSESSMENT_REPORT:
            return {
                ...state,
                exerciseWiseStrengthAssessmentReport: payload,
            };

        case types.EXERCISE_CATEGORY_WISE_WORKOUT_COMPLETED_REPORT:
            return {
                ...state,
                exerciseCategoryWiseWorkoutCompletedReport: payload,
            };

        case types.TOTAL_WEIGHTS_LIFTED_REPORT:
            return {
                ...state,
                totalWeightsLiftedReport: payload,
            };


        case types.WORKOUT_SESSION_SPLIT_MINUTES:
            return {
                ...state,
                workoutSessionSplitMinutes: payload,
            };

        case types.TOTAL_WORKOUTS_COMPLETED_HOURLY_WISE:
            return {
                ...state,
                totalWorkoutsCompletedHourly: payload,
            };

        // const newState = cloneDeep(state);
        // merge(newState.totalWorkoutsCompletedHourly, payload);
        // return newState;

        default:
            return state;
    }
};

export default WorkOutAnalyticsReportReducer;
